import { Fragment } from "react";

//STYLES
import styles from "../NavBar.module.scss";

//UI COMPONENTS
import Skeleton from "../../Skeleton/Skeleton";

const LinkSkeleton = () => {
  const { linkSkeletonContainer } = styles;

  return (
    <div className={linkSkeletonContainer}>
      <Skeleton />
    </div>
  );
};

export const NavbarSkeleton = () => {
  const { navbarSkeleton } = styles;
  return (
    <div className={navbarSkeleton}>
      {[1, 2, 3, 4, 5, 6, 7, 8].map((id) => (
        <Fragment key={id}>
          <LinkSkeleton />
        </Fragment>
      ))}
    </div>
  );
};
